import React, { useState } from "react";
import Table from "./Table";

const Calling = () => {
  const [canUpdate] = useState(true);

  return <Table canUpdate={canUpdate} canDelete={false} />;
};

export default Calling;
